
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/csr/industry/time-honored",
      function () {
        return require("private-next-pages/csr/industry/time-honored.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/csr/industry/time-honored"])
      });
    }
  